import React from 'react';

import {TransferStructuredTableMetadata} from 'notebook/integrations/samples/TransferStructuredTableAdapter';
import SimpleTableEditable, {standaloneProps} from 'notebook/simple-tables/SimpleTableEditable';
import {
  InventoryTableMetadata,
  SchemaAndColumnGroup,
  StructuredTableKind,
} from 'notebook/structured-tables/StructuredTableConstants';
import {STRUCTURED_TABLE_PLUGIN} from 'notebook/structured-tables/StructuredTablePlugin';
import {StructuredTableInsertionContextValue} from 'notebook/structured-tables/util/StructuredTableInsertionContext';
import {SchemaFieldSelector} from 'schemas/SchemaFieldSelectorConstants';
import FormGroup from 'ui-library/bs/FormGroup';
import Label from 'ui-library/bs/Label';

export interface InventoryTablePreviewProps {
  inventoryTableKind: StructuredTableKind.TRANSFER | StructuredTableKind.INVENTORY;
  schemas: Array<SchemaAndColumnGroup>;
  name?: string | null;
  cid: string;
  selectorsById: {[selectorId: string]: SchemaFieldSelector};
  metadata: TransferStructuredTableMetadata | InventoryTableMetadata;
  structuredTableInsertionContext: StructuredTableInsertionContextValue;
}

export function InventoryTablePreview(props: InventoryTablePreviewProps): JSX.Element {
  const adapter = STRUCTURED_TABLE_PLUGIN.get(props.inventoryTableKind);
  const structuredTable = {
    ...adapter.createTable({
      name: props.name ?? props.schemas[0].name,
      schemas: props.schemas,
      entryId:
        props.inventoryTableKind === StructuredTableKind.TRANSFER
          ? 'etr_transferPreviewTable'
          : 'etr_inventoryPreviewTable',
      metadata: props.metadata,
      selectorsById: props.selectorsById,
      structuredTableInsertionContext: props.structuredTableInsertionContext,
    }),
    cid: props.cid,
  };

  const table = adapter.toTable(adapter.prepareForPreview(structuredTable));

  return (
    <FormGroup className="u-spacing-top">
      <Label>Preview</Label>
      <div className="modal-mediocre-tableWrapper">
        <SimpleTableEditable
          {...standaloneProps}
          table={table}
          cid={props.cid}
          locked={true}
          hideFormulaBox={true}
          viewer={true}
          icon={adapter.getTableIcon(structuredTable)}
          enableFormulas={false}
          hasPlaceholderRows={true}
          storeState={() => {}}
          tableLabel={adapter.getDisplayName(structuredTable)}
          isLeftAlignColumnHeader={true}
        />
      </div>
    </FormGroup>
  );
}
